export default "__VITE_ASSET__DAe_l4_c__"